import { HeroSource, HeroHistoryStatus } from '@profile/src/models';
export const formatStatus = status => {
  switch (status) {
    case HeroHistoryStatus.SUCCESS:
      return {
        displayName: 'Completed',
        style: 'completed'
      };

    case HeroHistoryStatus.PROCESSING:
      return {
        displayName: 'Processing',
        style: 'processing'
      };

    case HeroHistoryStatus.FAILED:
      return {
        displayName: 'Cancelled',
        style: 'cancelled'
      };

    default:
      return undefined;
  }
};
export const formatType = status => {
  switch (status) {
    case HeroSource.OPEN_BOX:
      return 'Open Box';

    case HeroSource.LISTING:
      return 'Listing';

    case HeroSource.SOLD:
      return 'Sold';

    case HeroSource.PURCHASE:
      return 'Purchase';

    case HeroSource.NON_NFT_SHOP:
      return 'Non-NFT Shop';

    case HeroSource.MINT:
      return 'Mint';

    case HeroSource.NEW_USER_REWARD:
      return 'New User Reward';

    case HeroSource.FIRST_FEE:
      return 'First Free';

    case HeroSource.RANKING:
      return 'Ranking';

    case HeroSource.UNLIST:
      return 'Unlist';

    case HeroSource.FUSION_PRODUCT:
      return 'Fusion-Product';

    case HeroSource.WHEEL_REWARD:
      return 'Giftmas Fortune Wheel';

    default:
      return '';
  }
};